import Vue from "vue";
import ViewUI from "view-design";
import locale from "view-design/dist/locale/en-US";

// import style
import "view-design/dist/styles/iview.css";

Vue.use(ViewUI, { locale });
